import React from "react";

import { Deal } from "custom-types/Deals";

import TrackImpression from "components/TrackImpression";

import DealsCarousel from "./DealsCarousel";

type Props = {
  deals: Deal[];
  page: string;
  title: string;
};

export const DealsSection = ({ deals, page, title }: Props): JSX.Element => (
  <div className="container" data-testid="deals-section" role="complementary">
    <TrackImpression category="Deals Carousel" label="Deals Carousel">
      <DealsCarousel deals={deals} page={page} title={title} />
    </TrackImpression>
  </div>
);

export default DealsSection;
